import { render, staticRenderFns } from "./AlertAnimation.vue?vue&type=template&id=0b575120&"
import script from "./AlertAnimation.vue?vue&type=script&lang=js&"
export * from "./AlertAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports